import { SalaryIncome as SalaryIncomeTemplate } from '@jbc-year-end-adj/2024/features/questions/templates/SalaryIncome';
import { Form } from './Form';
import { Question } from '@jbc-year-end-adj/2024/features/questions/types';
import { useEmployeeQuery } from '@jbc-year-end-adj/2024/hooks/graphql/useQuery';
import { LoadingPage } from '../../Loading';
import { INCOME } from './query';

type SalaryIncomeProps = {
  question: Question;
};

export const SalaryIncome = ({ question }: SalaryIncomeProps) => {
  const { data, loading } = useEmployeeQuery(INCOME);
  const profile = data?.request?.profile;

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <SalaryIncomeTemplate question={question} initiallyOpen={true}>
      <Form profile={profile} />
    </SalaryIncomeTemplate>
  );
};
